import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(main)/metronome/client.tsx");
